export default {
	ul: {
		'& .MuiPaginationItem-page': {
			fontWeight: 500,
			fontSize: 12,
			lineHeight: 22,
		},
		'& .MuiPaginationItem-page.Mui-selected': {
			color: '#fff'
		}
	}
};
